export { default } from './TouchFeedback';


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/rmc-feedback/es/index.js
// module id = 703
// module chunks = 0